export type ValueListConfig = {
  values: string[]
}

export function isValueListConfig(config: unknown): config is ValueListConfig {
  return typeof config === 'object' && config !== null && config !== undefined && 'values' in config
     && Array.isArray(config?.values)
}